import { IMenuStateTotals } from '../../interfaces/menu';

interface IAction {
    type: string,
    payload?: any
}

const DEFAULT_STATE: IMenuStateTotals = {
    TotalUsers: 0,
    TotalPublished: 0,
    TotalPendingPublication: 0,
    TotalNotPublished: 0
};

export default (state = DEFAULT_STATE, action: IAction) => {
    switch (action.type) {
        case 'SET_MENU_TOTALS':
            state = {
                ...state,
                ...action.payload
            };
            break;
    }

    return state;
};
